<script>
  export let checked = false;
  export let disabled = false;
  export let labelText = "";
  export let hideLabel = false;
  export let name = "";
  export let title = undefined;
  export let id = "ccs-" + Math.random().toString(36);
  export let ref = null;
  export let faded = false
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  $: dispatch("check", checked);
</script>

<div
  class:form-item="{true}"
  class:checkbox-wrapper="{true}"
  class:faded
  {...$$restProps}
  on:click
  on:mouseover
  on:mouseenter
  on:mouseleave
>
  <input
    bind:this="{ref}"
    type="checkbox"
    checked="{checked}"
    disabled="{disabled}"
    id="{id}"
    name="{name}"
    class:checkbox="{true}"
    on:change
    on:change="{() => {
      checked = !checked;
    }}"
  />
  <label for="{id}" title="{title}" class:checkbox-label="{true}">
    <span
      class:checkbox-label-text="{true}"
      class:visually-hidden="{hideLabel}"
    >
      {labelText}
    </span>
  </label>
</div>

<style>
  .form-item {
    margin-bottom: 1rem;
  }
  .checkbox {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    white-space: nowrap;
    border: 0;
    visibility: inherit;
    clip: rect(0,0,0,0);
  }
  .checkbox-label {
    vertical-align: initial;
    border: 0;
    position: relative;
    display: flex;
    padding-left: 2.2rem;
    line-height: 2rem;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }
  .checkbox-label:before {
    position: absolute;
    top: 0.2rem;
    left: 0;
    width: 1.6rem;
    height: 1.6rem;
    margin: 0;
    background-color: initial;
    border: 2px solid var(--c-text);
    content: "";
    transition-property: background-color, border-color;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }
  .checkbox:checked + .checkbox-label {
    color: var(--c-accent);
  }
  .checkbox:checked + .checkbox-label:hover {
    color: var(--c-text);
  }
  .checkbox:checked + .checkbox-label:before {
    border-color: var(--c-accent);
    background-color: var(--c-accent);
  }
  .checkbox:checked + .checkbox-label:after {
    position: absolute;
    top: 0.2rem;
    left: 0.3rem;
    width: 1rem;
    height: 0.5rem;
    border-bottom: 2px solid var(--c-text-on-fill-hover);
    border-left: 2px solid var(--c-text-on-fill-hover);
    transform: rotate(-45deg);
    transform-origin: bottom right;
    content: "";
  }
  .checkbox-label.checked {
    background-color: hsl(0deg 0% 9%);
    border-color: hsl(0deg 0% 9%);
    border-width: 1px;
  }
  .faded .checkbox-label {
    color: var(--c-text-faded);
  }
  .faded .checkbox-label:hover {
    color: var(--c-text-hover);
  }
  .faded .checkbox-label:before {
    border-color: var(--c-text-faded);
  }
</style>